import SearchIcon from '@material-ui/icons/Search';

import { ModalButton } from '../../../components/ModalButton';

export const SearchButton = ({
  toggleSearcher,
}: {
  toggleSearcher: () => void;
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        right: 65,
        top: 16,
        zIndex: 5,
        pointerEvents: 'auto',
      }}
    >
      <ModalButton onClick={toggleSearcher}>
        <SearchIcon fontSize="large" />
      </ModalButton>
    </div>
  );
};
